export enum TASK_STATES {
  TODO = 'TODO',
  PROGRESS = 'PROGRESS',
  REVIEW = 'REVIEW',
  COMPLETED = 'COMPLETED'
}

export const taskStates = {
  [TASK_STATES.TODO]: TASK_STATES.TODO,
  [TASK_STATES.PROGRESS]: 'IN-' + TASK_STATES.PROGRESS,
  [TASK_STATES.REVIEW]: TASK_STATES.REVIEW,
  [TASK_STATES.COMPLETED]: TASK_STATES.COMPLETED
};

export enum PROJECT_STATUS {
  ACTIVE = 'ACTIVE',
  ARCHIVE = 'ARCHIVE'
}

export enum PROJECT_TABS {
  TASKS = 'tasks',
  USERS = 'users',
  SETTINGS = 'settings',
  TARGETS = 'targets',
  ANALYTICS = 'analytics'
}

export interface ReactSelectOption {
  label: string;
  value: string;
}

export const PROJECT_TAG_OPTIONS = [
  { label: 'UI/UX', value: 'UI/UX' },
  { label: 'Firmware', value: 'Firmware' },
  { label: 'Frontend', value: 'Frontend' },
  { label: 'Backend', value: 'Backend' },
  { label: 'Development', value: 'Development' },
  { label: 'Web', value: 'Web' },
  { label: 'Mobile', value: 'Mobile' },
  { label: 'Software', value: 'Software' },
  { label: 'Hardware', value: 'Hardware' },
  { label: 'Construction', value: 'Construction' },
  { label: 'Reports', value: 'Reports' },
  { label: 'Sales', value: 'Sales' }
] as ReactSelectOption[];

export enum TASK_TYPES {
  TASK = 'TASK',
  FEATURE = 'FEATURE',
  BUG = 'BUG',
  INFO = 'INFO',
  SUPPORT = 'SUPPORT'
}

export const TASK_TYPE_OPTIONS = [
  { value: TASK_TYPES.TASK, label: TASK_TYPES.TASK },
  { value: TASK_TYPES.FEATURE, label: TASK_TYPES.FEATURE },
  { value: TASK_TYPES.BUG, label: TASK_TYPES.BUG },
  { value: TASK_TYPES.INFO, label: TASK_TYPES.INFO },
  { value: TASK_TYPES.SUPPORT, label: TASK_TYPES.SUPPORT }
];
